import AdminLinks from "features/Header/Menu/adminLinks/AdminLinks";
import { ExternalLinks } from "features/Header/Menu/externalLinks/ExternalLinks";
import { MenuContent } from "features/Header/Menu/MenuStyles";
import ProfileDisplay from "features/Header/Menu/ProfileDisplay";
import { useEffect, useState } from "react";
import Overlay from "shared/components/Overlay";
import { IconButton, tokens } from "shared/components/Spor";
import { HamburgerIcon } from "shared/icons/HamburgerIcon";

export const Menu = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";

    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen]);

  return (
    <div>
      <MenuContent $open={menuOpen}>
        <ProfileDisplay />
        <ExternalLinks />
        <AdminLinks />
      </MenuContent>
      <Overlay
        $open={menuOpen}
        onClick={() => setMenuOpen(false)}
        zIndex={48}
      />
      <IconButton
        zIndex={1002}
        marginRight={tokens.default.size.spacing[2]}
        style={{ display: "flex" }}
        icon={<HamburgerIcon open={menuOpen} />}
        onClick={() => setMenuOpen(!menuOpen)}
        variant="ghost"
      />
    </div>
  );
};
